<ng-container *ngIf="!isLoading else showLoading">
    <form [formGroup]="actionForm" *ngIf="stage === 1" class="cas-flex-column cas-form-floating">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content [mediumField]="true">
                    <input type="text" formControlName="name" placeholder="Action name" pInputText>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content [longerField]="true">
                    <input type="text" formControlName="description" pInputText>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="types?.entityTypes">
                <acabim-form-input-label>Entity type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        [options]="types?.entityTypes"
                        formControlName="entityType"
                        placeholder="Select an entity type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="types?.entitySubTypes">
                <acabim-form-input-label>Entity sub-type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            [options]="types?.entitySubTypes"
                            formControlName="entitySubType"
                            placeholder="Select an entity sub-type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="types?.targetTypes">
                <acabim-form-input-label>Target type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            [options]="types?.targetTypes"
                            formControlName="targetType"
                            placeholder="Select a target type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="types?.categories">
                <acabim-form-input-label>Category</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            [options]="types?.categories"
                            formControlName="category"
                            placeholder="Select a category"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="types?.subCategories">
                <acabim-form-input-label>Sub-category</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            [options]="types?.subCategories"
                            formControlName="subCategory"
                            placeholder="Select a sub-category"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="types?.expenseTypes">
                <acabim-form-input-label>Expense type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        [options]="types?.expenseTypes"
                        formControlName="expenseType"
                        placeholder="Select an expense type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="onCancel()">Cancel</button>
            <button class="cas-button-action cas-button-right"  (click)="stage = 2">Next</button>
        </div>
    </form>

    <form *ngIf="stage === 2" [formGroup]="actionForm" class="cas-flex-column cas-form-floating">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Repeating</acabim-form-input-label>
                <acabim-form-input-content>
                   <p-checkbox label="Action may be repeated" formControlName="repeating" [binary]="true"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Priority</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        [options]="priorityTypes"
                        formControlName="priority"
                        placeholder="Select a priority"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Status</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox label="Active status" formControlName="status" [binary]="true"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="onCancel()">Cancel</button>
                <button (click)="stage = 1">Back</button>
                <button *ngIf="!hasWork" class="cas-button-action cas-button-right" (click)="onSubmit()">{{mode | titlecase}}</button>
                <button *ngIf="hasWork" class="cas-button-action cas-button-right" (click)="handleWorkOrderActions()">Next</button>
            </div>
        </acabim-form-block>
    </form>

    <form *ngIf="stage === 3" [formGroup]="actionForm" class="cas-flex-column cas-form-floating">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
            <acabim-form-input-wrapper *ngIf="workTypes.length > 0">
                <acabim-form-input-label>Work type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        [options]="workTypes"
                        formControlName="workOrderType"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select a work order type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="workCategories.length > 0">
                <acabim-form-input-label>Work category</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        [options]="workCategories"
                        formControlName="workOrderCategory"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select a work order category"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="workTasks.length > 0">
                <acabim-form-input-label>Work task</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            [options]="workTasks"
                            formControlName="workOrderTask"
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select a work order task"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="onCancel()">Cancel</button>
                <button (click)="stage = 1">Back</button>
                <button class="cas-button-action cas-button-right" (click)="onSubmit()">{{mode | titlecase}}</button>
            </div>
        </acabim-form-block>
    </form>

    <ng-container *ngIf="stage === 4">
        <div class="cas-info">
            <h4>Done!</h4>
            <p *ngIf="mode === 'add'">You have successfully created a new action.</p>
            <p *ngIf="mode === 'update'">You have successfully updated action.</p>
            <button class="cas-button-action" (click)="onComplete()">Close</button>
        </div>
    </ng-container>
</ng-container>

<ng-template #showLoading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

